/** Display US numbers consistently; keep incomplete and international values intact. */
export function formatPhoneNumber(value: string | null | undefined): string {
  if (!value) return "";
  const digits = value.replace(/\D/g, "");
  const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  return national.length === 10 ? `(${national.slice(0, 3)})${national.slice(3, 6)}-${national.slice(6)}` : value;
}
